import { useCallback, useMemo } from "react";

import { getPackageHref } from "app/common/hrefs";
import { ANNUAL_CAMPAIGN_ID } from "app/components/AnnualPromoModal/configs/buildAnnualCampaignConfig";
import type { AnnualPromoType } from "app/components/AnnualPromoModal/utils/campaignTypes";
import type { IModalProps } from "app/components/hooks/useDiscounts";
import { useDiscounts } from "app/components/hooks/useDiscounts";

interface IUseAnnualPromoCampaignAPI {
    hasAnnualPromoCta: boolean;
    annualPromoCtaType: AnnualPromoType | null;
    onAnnualPromoCtaClick: () => void;
    discountModalProps: IModalProps | null;
}

export const useAnnualPromoCampaign = (): IUseAnnualPromoCampaignAPI => {
    const { hasDiscountCampaign, discountModalProps } = useDiscounts();

    const annualPromoCtaType = useMemo((): AnnualPromoType | null => {
        if (!hasDiscountCampaign) {
            return null;
        }

        return ANNUAL_CAMPAIGN_ID;
    }, [hasDiscountCampaign]);

    const onAnnualPromoCtaClick = useCallback(() => {
        if (!annualPromoCtaType) {
            return;
        }

        window.open(`${getPackageHref()}?withUpgradeToAnnual=true&isAnnualPromo`);
    }, [annualPromoCtaType]);

    return {
        hasAnnualPromoCta: annualPromoCtaType !== null,
        annualPromoCtaType,
        onAnnualPromoCtaClick,
        discountModalProps,
    };
};
